export default "__VITE_ASSET__CbXWybrL__"